module.exports = __webpack_public_path__ + "static/media/optExtendSideAngle.ce43af84.jpg";